import React from 'react';
import { Link } from 'react-router-dom';
import './RecipeCard.css';

const RecipeCard = ({ recipe }) => {
  return (
    <Link to={`/recipe/${recipe.id}`} className="recipe-card-link">
      <div className="recipe-card">
        <div className="recipe-card-image">
          {recipe.coverImage ? (
            <img src={recipe.coverImage} alt={recipe.title} />
          ) : (
            <div className="recipe-card-placeholder">
              <span>{recipe.title.charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="recipe-content">
          <h3 className="recipe-title">{recipe.title}</h3>
        </div>
      </div>
    </Link>
  );
};

export default RecipeCard;
